import React, { JSX } from 'react';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { SummaryGroup } from '../../../../Summary/SummaryGroup';
import { getVisaLabelFromValue } from 'data';
import { useTranslation } from "react-i18next";

function VisaPrepAdditionalHistoryStep2Info(props: IVisaPrepForm): JSX.Element {
    const { t } = useTranslation('forms.visa');
  const renderOtherUKVisas = (): React.ReactNode[] => {
    const allOtherUKVisas: React.ReactNode[] = [];
    if (props.otherUkVisas && props.otherUkVisas.length) {
      for (const [i, ukVisa] of props.otherUkVisas.entries()) {
        allOtherUKVisas.push(
          <React.Fragment key={i}>
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.OTHER_UK_VISA_TYPE}-${i}`}
              value={getVisaLabelFromValue(ukVisa.visaType)}
              label={t('forms.visa:otherTerritoryVisaTypeOfVisa', { i: i + 1 })}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.OTHER_UK_VISA_DATE_OF_ISSUE}-${i}`}
              label={t('forms.visa:otherTerritoryVisaDateOfIssue', { i: i + 1 })}
              value={ukVisa.issueDate}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.OTHER_UK_VISA_DATE_OF_EXPIRY}-${i}`}
              label={t('forms.visa:otherTerritoryVisaDateOfExpiry', { i: i + 1 })}
              value={ukVisa.expiryDate}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.OTHER_UK_VISA_COUNTRY}-${i}`}
              label={t('forms.visa:otherTerritoryVisaCountryTerrito', { i: i + 1 })}
              value={ukVisa.country}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.OTHER_UK_VISA_ISSUING_AUTH}-${i}`}
              value={ukVisa.issuingAuthority}
              label={t('forms.visa:otherTerritoryVisaIssuingAuthori', { i: i + 1 })}
            />
          </React.Fragment>,
        );
      }
    }
    return allOtherUKVisas;
  };
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_OTHER_UK_VISAS}
        label={t('forms.visa:hasOtherUkVisas2')}
        fullLabel={
          'Have you been issued any visas for UK Overseas Territories or Commonwealth Countries in the last 10 years? (Note: not including the UK itself):'
        }
        value={boolToYesNo(props.hasOtherUkVisas)}
      />
      {props.hasOtherUkVisas ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            label={t('forms.visa:howManyVisasHaveYouBeenIssued')}
            value={props.otherUkVisas?.length}
          />

          <SummaryGroup title={t('forms.visa:otherUkVisas2')} key={'other-uk-visas'}>
            {renderOtherUKVisas()}
          </SummaryGroup>
        </>
      ) : null}
    </>
  );
}

export default VisaPrepAdditionalHistoryStep2Info;
